import { useState } from 'react';
import campaignTypes from '../data/campaignTypes.json';
import { CampaignTypesCategoryColors } from '@/utils/colorUtils';
import type { VisibleCategories } from '@/types';

/**
 * This hook is used to manage the visible categories for the campaign types modal.
 * @returns The visible categories and a function to set the visible categories.
 */
export const useVisibleCategories = () => {
  const initialState = Object.keys(campaignTypes).reduce((acc, cat, i) => {
    acc[cat as keyof VisibleCategories] = { color: CampaignTypesCategoryColors[i], visible: true };

    return acc;
  }, {} as VisibleCategories);

  const [visibleCategories, setVisibleCategories] = useState<VisibleCategories>(initialState);

  return { visibleCategories, setVisibleCategories };
};
